import React from 'react';
import { Switch } from 'antd';

const SwitchBasic = ({ ...props }) => {
  return (
    <Switch {...props} checkedChildren="ON" unCheckedChildren="OFF" /> 
  );
};
export default SwitchBasic;
